import { useEffect } from "react";

const KlaviyoScript = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Yvk592";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null; // KlaviyoScript doesn't render anything
};

export default KlaviyoScript;
